import { render, staticRenderFns } from "./UpDownCustomerDistribution.vue?vue&type=template&id=227d66e6&scoped=true"
import script from "./UpDownCustomerDistribution.vue?vue&type=script&lang=js"
export * from "./UpDownCustomerDistribution.vue?vue&type=script&lang=js"
import style0 from "./UpDownCustomerDistribution.vue?vue&type=style&index=0&id=227d66e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d66e6",
  null
  
)

export default component.exports